import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, ChevronDown, Heart, Anchor } from "lucide-react";
import CurrencySelector from "@/components/CurrencySelector";
import LanguageSelector from "@/components/LanguageSelector";
import { CitySearchPanel } from "@/components/CitySearchCombobox";

const MobileMenu = ({
  currentCity,
  onCitySelect,
  scrollToSection,
  selectedCurrency,
  onCurrencyChange,
  lang,
  onLangChange,
  settings,
  t,
  availableLanguages,
}) => {
  const [isCityOpen, setIsCityOpen] = useState(false);

  const handleCitySelect = (slug) => {
    setIsCityOpen(false);
    onCitySelect(slug);
  };

  return (
    <div className="md:hidden py-4 border-t border-gray-100 bg-white rounded-b-2xl shadow-lg animate-fade-in max-h-[calc(100vh-4rem)] overflow-y-auto overscroll-contain" data-testid="mobile-menu">
      <nav className="flex flex-col gap-2">
        <button
          onClick={() => scrollToSection("catalog")}
          className="py-3 px-4 text-left text-gray-700 hover:bg-pink-50 hover:text-pink-600 rounded-xl transition-colors font-semibold"
        >
          {t("nav.catalog")}
        </button>
        <button
          onClick={() => scrollToSection("advantages")}
          className="py-3 px-4 text-left text-gray-700 hover:bg-pink-50 hover:text-pink-600 rounded-xl transition-colors font-semibold"
        >
          {t("nav.advantages")}
        </button>
        <button
          onClick={() => scrollToSection("reviews")}
          className="py-3 px-4 text-left text-gray-700 hover:bg-pink-50 hover:text-pink-600 rounded-xl transition-colors font-semibold"
        >
          {t("nav.reviews")}
        </button>

        {/* Weddings hub */}
        <Link
          to={`/weddings${lang !== "ru" ? `?lang=${lang}` : ""}`}
          className="py-3 px-4 text-left rounded-xl transition-all flex items-center gap-2 font-semibold bg-gradient-to-r from-pink-500 to-rose-500 text-white shadow-md shadow-pink-100 hover:from-pink-600 hover:to-rose-600"
          data-testid="mobile-weddings-link"
        >
          <Heart className="w-4 h-4 shrink-0" fill="currentColor" />
          {lang === "tr" ? "Düğün çiçekçiliği" : lang === "en" ? "Wedding floristry" : "Свадебная флористика"}
        </Link>

        {/* Yachts hub */}
        <Link
          to={`/yachts${lang !== "ru" ? `?lang=${lang}` : ""}`}
          className="py-3 px-4 text-left rounded-xl transition-all flex items-center gap-2 font-semibold border border-[#C9A87C]/50 text-[#8B6F47] hover:bg-[#FAF5EE]"
          data-testid="mobile-yachts-link"
        >
          <Anchor className="w-4 h-4 shrink-0" />
          {lang === "tr" ? "Yat çiçekleri" : lang === "en" ? "Yacht flowers" : "Оформление яхт"}
        </Link>

        {/* City dropdown */}
        <div className="border-t border-gray-100 pt-2 mt-1">
          <button
            onClick={() => setIsCityOpen(!isCityOpen)}
            className="py-3 px-4 text-left text-gray-700 hover:bg-pink-50 hover:text-pink-600 rounded-xl transition-colors flex items-center gap-2 font-semibold w-full"
            data-testid="mobile-city-dropdown"
          >
            <MapPin className="w-4 h-4" />
            {lang === "tr" ? (currentCity?.nameTr || currentCity?.nameEn) : (lang === "en" ? currentCity?.nameEn : currentCity?.name || "Город")}
            <ChevronDown className={`w-3.5 h-3.5 ml-auto transition-transform ${isCityOpen ? "rotate-180" : ""}`} />
          </button>
          {isCityOpen && (
            <div className="mx-2 mt-1 rounded-2xl border border-gray-100 bg-white shadow-inner overflow-hidden" data-testid="mobile-city-search">
              <CitySearchPanel
                lang={lang}
                selectedSlug={currentCity?.slug}
                onSelect={(city) => handleCitySelect(city.slug)}
                autoFocus
                listMaxClass="max-h-[45vh]"
                testIdPrefix="mobile-city-option"
              />
            </div>
          )}
        </div>

        {/* Currency */}
        <CurrencySelector selectedCurrency={selectedCurrency} onCurrencyChange={onCurrencyChange} isMobile />

        {/* Language */}
        <LanguageSelector selectedLang={lang} onLangChange={onLangChange} isMobile availableLanguages={availableLanguages} />

        {/* Phone */}
        <a
          href={`tel:${settings?.whatsapp || "+905316224378"}`}
          className="py-3 px-4 text-pink-600 hover:bg-pink-50 rounded-xl transition-colors flex items-center gap-2 font-semibold"
        >
          <Phone className="w-4 h-4" />
          {settings?.whatsapp || "+90 531 622 43 78"}
        </a>
      </nav>
    </div>
  );
};

export default MobileMenu;
